// Sidebar Routers
let _menus = {
    'message.home': {
        action: 'zmdi-home',
        title: 'Home',
        items: null,
        path: '/',
        active: true,
        can: 'client-list'
    },
    'message.programs': {
        action: 'zmdi-folder-star',
        title: 'Programs',
        items: null,
        path: '/programs',
        active: true,
        can: 'installment-list'
    },
    'message.semester': {
        action: 'zmdi-collection-bookmark',
        title: 'Semesters',
        items: null,
        path: '/semesters',
        active: true,
        can: 'installment-list'
    },
    'message.instructors': {
        action: 'zmdi-accounts-list',
        title: 'Instructors',
        items: null,
        path: '/instructors',
        active: true,
        can: 'installment-list'
    },
    'message.courses': {
        action: 'zmdi-book',
        title: 'Courses',
        items: null,
        path: '/courses',
        active: true,
        can: 'client-list'
    },
    'message.faculties': {
        action: 'zmdi-border-all',
        title: 'Faculties',
        items: null,
        path: '/faculty',
        active: true,
        can: 'client-list'
    },
    'message.students': {
        action: 'zmdi-graduation-cap',
        title: 'Students',
        items: null,
        path: '/students',
        active: true,
        can: 'installment-list'
    },


    'message.admins': {
        action: 'zmdi zmdi-accounts-alt',
        title: 'Admins',
        items: null,
        path: '/admins',
        active: true,
        can: 'notes-list'
    }
}


let student_menus = {
    'message.home': {
        action: 'zmdi-home',
        title: 'Home',
        items: null,
        path: '/',
        active: true,
        can: 'client-list'
    },
    'message.courses': {
        action: 'zmdi-book',
        title: 'Profile',
        items: null,
        path: '/student/profile',
        active: true,
        can: 'client-list'
    },

}

let instructor_menus = {
    'message.home': {
        action: 'zmdi-home',
        title: 'Home',
        items: null,
        path: '/',
        active: true,
        can: 'client-list'
    },
    'message.courses': {
        action: 'zmdi-book',
        title: 'Profile',
        items: null,
        path: '/instructor/profile',
        active: true,
        can: 'client-list'
    },

}

// for (let [key, value] of Object.entries(_menus)) {
// 	console.log( $store );
// 	if( this.$store.getters.getUser.permissions.indexOf(value.can) !== -1 ){
// 		delete _menus[key];
// 	}
//   }


export  {
    _menus,
    student_menus,
    instructor_menus
}
